function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7567 5.06681C15.7567 3.93946 14.8187 3 13.6931 3H5.06358C3.93799 3 3 3.93946 3 5.06681V16.7161C3 17.8434 3.93799 18.7829 5.06358 18.7829H10.6165L10.7666 17.8434C10.8416 17.4301 11.0292 17.0543 11.3294 16.7536L15.7567 12.3194V5.06681ZM6.00157 6.00626H9.00314C9.41585 6.00626 9.75353 6.34447 9.75353 6.75783C9.75353 7.17119 9.41585 7.50939 9.00314 7.50939H6.00157C5.58885 7.50939 5.25118 7.17119 5.25118 6.75783C5.25118 6.34447 5.58885 6.00626 6.00157 6.00626ZM9.75353 13.5219H6.00157C5.58885 13.5219 5.25118 13.1837 5.25118 12.7704C5.25118 12.357 5.58885 12.0188 6.00157 12.0188H9.75353C10.1662 12.0188 10.5039 12.357 10.5039 12.7704C10.5039 13.1837 10.1662 13.5219 9.75353 13.5219ZM12.7551 10.5157H6.00157C5.58885 10.5157 5.25118 10.1775 5.25118 9.76409C5.25118 9.35073 5.58885 9.01252 6.00157 9.01252H12.7551C13.1678 9.01252 13.5055 9.35073 13.5055 9.76409C13.5055 10.1775 13.1678 10.5157 12.7551 10.5157Z",
  fill: "#00A94F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6341 13.0338L19.6961 12.0944C19.3209 11.7186 18.6455 11.5307 17.9702 12.2447L12.4173 17.8063C12.3422 17.8814 12.2672 17.9942 12.2672 18.1069L11.8545 20.3616C11.817 20.5495 11.892 20.7374 12.0046 20.8501C12.1171 20.9628 12.2672 21.0004 12.4173 21.0004C12.4548 21.0004 12.4923 21.0004 12.5298 21.0004L14.781 20.5871C14.8936 20.5495 15.0061 20.5119 15.0812 20.4368L20.6341 14.8752C21.1218 14.3866 21.1218 13.5599 20.6341 13.0338Z",
  fill: "#00A94F"
});

function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.c8acd624.svg";
export { ForwardRef as ReactComponent };